const LOAD_INCIDENTS_BY_DEVICE_ID = "incidents::load-by-device-id";
const LOAD_INCIDENTS_BY_DEVICE_ID_SUCCESS =
  "incidents::load-by-device-id::success";

export { LOAD_INCIDENTS_BY_DEVICE_ID, LOAD_INCIDENTS_BY_DEVICE_ID_SUCCESS };
